<template>
  <div class="site-view modal-view">
    <section
      class="page-section nav-section"
      style="background: white; padding-top: 30px"
    >
      <div class="container">
        <div class="article-nav">
          <h1>The Options</h1>
          <hr class="header-underline" />
          <div class="navs">
            <div
              v-for="(strategy, index) in strategies.strats"
              :key="`strategies_navs_${index}`"
            >
              <h2
                v-if="index !== strategies.selected"
                @click="() => selectStrategy(index)"
              >
                {{ strategy.shortHeader }}
              </h2>
              <h2 v-if="index === strategies.selected" class="active">
                {{ strategy.shortHeader }}
              </h2>
            </div>
          </div>
          <div class="selects">
            <form>
              <select v-model="strategies.selected">
                <option
                  v-for="(strategy, index) in strategies.strats"
                  :key="`strategies_option_${index}`"
                  :value="index"
                >
                  {{ strategy.header }}
                </option>
              </select>
            </form>
          </div>
          <hr style="margin-bottom: 4rem" />

          <div class="nav-content">
            <div class="row">
              <div class="col s12 l6">
                <div class="nav-text">
                  <h2>{{ strategies.strats[strategies.selected].header }}</h2>
                  <ul>
                    <li
                      v-for="(text, index) in strategies.strats[
                        strategies.selected
                      ].text"
                      :key="`strategies_text_${index}`"
                    >
                      {{ text }}
                      <ul
                        v-if="
                          strategies.strats[strategies.selected].subtext &&
                          index === 0
                        "
                      >
                        <li
                          v-for="(sub, j) in strategies.strats[
                            strategies.selected
                          ].subtext"
                          :key="`tab_${index}_subtext_${j}`"
                        >
                          {{ sub }}
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <div>
                    <p
                      v-for="(p, index) in strategies.strats[
                        strategies.selected
                      ].additionalText"
                      :key="`strategies_additionaltext_${index}`"
                    >
                      {{ p }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col s12 l6">
                <InnerImageZoom
                  :src="strategies.strats[strategies.selected].map"
                  :zoomSrc="strategies.strats[strategies.selected].map"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import "vue-inner-image-zoom/lib/vue-inner-image-zoom.css";
import InnerImageZoom from "vue-inner-image-zoom";

export default {
  name: "OptionTabs",
  components: {
    InnerImageZoom,
  },
  methods: {
    selectStrategy(index) {
      this.strategies.selected = index;
    },
  },
  data() {
    return {
      strategies: {
        selected: 0,
        strats: [
          {
            shortHeader: "Option 1",
            header: "Option 1: Bypass Option",
            text: [],
            additionalText: [
              "This option consists of an offline bypass from the A141, around the north of St Ives, to the A1123 to the east of St Ives. ",
              "A new connection would be made between the A1123 and the A1096. The A1096 would be upgraded including its junction with Low Road.",
              "Bypass alignments are indicative and would avoid existing properties.",
            ],
            map: "https://firebasestorage.googleapis.com/v0/b/st-ives-d8044.appspot.com/o/Maps%2Fmaps1.png?alt=media&token=f6456ff3-1cdc-44f8-b7e9-9facebe795f7",
          },
          {
            shortHeader: "Option 2",
            header: "Option 2: Bypass Option",
            text: [],
            additionalText: [
              "This option consists of an offline bypass from the A141, around the north of St Ives, which connects with an upgraded Marley Road.",
              "Online upgrades in the form of junction and capacity improvements would be made to the B1040, A1123 and A1096 including the Low Road junction.",
              "Bypass alignments are indicative and would avoid existing properties.",
            ],
            map: "https://firebasestorage.googleapis.com/v0/b/st-ives-d8044.appspot.com/o/Maps%2Fmaps2.png?alt=media&token=c2c0c898-1e8f-49a2-bf3f-19678d8e36bb",
          },
          {
            shortHeader: "Option 3",
            header: "Option 3: Bypass Option",
            text: [],
            additionalText: [
              "This option consists of an offline bypass from the A141, around the north of St Ives, which connects with an upgraded Marley Road.",
              "From the B1040 an offline link would be provided to connect the B1040 with the A1123. ",
              "A new connection would be made between the A1123 and the A1096, and the A1096 upgraded including the Low Road junction.",
              "Bypass alignments are indicative and would avoid existing properties.",
            ],
            map: "https://firebasestorage.googleapis.com/v0/b/st-ives-d8044.appspot.com/o/Maps%2Fmap3.png?alt=media&token=c42221a0-2d76-4b15-bc06-a7e2e3712d1f",
          },
          {
            shortHeader: "Option 4",
            header: "Option 4: Local Junction Improvements",
            text: [],
            additionalText: [
              "Junction Signal Improvements",
              "Under option 4, to help improve traffic flow on the A1123, signal improvements would be made to the A1123/Hill Rise/High Leys junction and the A1123 Ramsey Road junction where possible.",
              "Access Restrictions",
              "To help reduce rat-running, access restrictions in the form of a ‘no-right turn’ restriction on vehicles turning into Needingworth Road from the A1123 west would be considered. ",
              "To help reduce rat-running, access restrictions would also be considered on the Meadow Lane approach to the A1096 roundabout to restrict vehicles entering the roundabout at this arm during peak times. Access would remain for vehicles accessing the Cattle Market Car Park. ",
              "Junction Geometric Improvements",
              "Geometric improvements would be considered to assist the movements of vehicles and increase capacity at the A1096/Low Road roundabout, the A1096/Meadow Lane roundabout, the A1123/B1040 roundabout and the A1123/A1096 roundabout.",
              "A1123/A1096 Road Layout",
              "A larger scale road layout change would be considered at the A1123/B1040 roundabout and the A1123/A1096 roundabout to help traffic flow in this area. This could consist of a one-way or two-way circular connection via the B1040/A1123/Compass Point. ",
              "A1123 Speed Reduction Measures",
              "Speed reduction measures on A1123 would be considered to help reduce the speeds of vehicles along this corridor. Measures could include public realm enhancements, narrowing of carriageway, installation of sustainable travel measures to make this section of the A1123 more representative of the 30mph speed limit. ",
            ],
            map: "https://firebasestorage.googleapis.com/v0/b/st-ives-d8044.appspot.com/o/Maps%2Fmap4.png?alt=media&token=95db9481-a557-4917-b056-2a2d8d717bb2",
          },
          {
            shortHeader: "Option 5",
            header: "Option 5: Sustainable Travel",
            text: [],
            additionalText: [
              "Under option 5, junction priority changes would be made at the Ramsey Road/North Road, North Road/Broad Leas and Globe Place/West Street/East Street junctions to help with the movement of buses through St Ives Town Centre.",
              "This option would include options to work with bus operators to improve and extend the existing Cambridgeshire Guided Bus services and coordinate with work on the future public transport schemes including: ",
              "Option 5 also includes measures identified through previous Study work to improve accessibility of bus stops, and to reduce the delay experienced by buses in St Ives town centre by rationalising on-street parking. ",
            ],
            map: "https://firebasestorage.googleapis.com/v0/b/st-ives-d8044.appspot.com/o/Maps%2Fmaps5.png?alt=media&token=f54abc8d-fd9b-4014-bad4-713e1f77cc3a",
          },
          {
            shortHeader: "Option 6",
            header: "Option 6: Non-Motorised User Options",
            text: [],
            additionalText: [
              "Option 6 includes a variety of options aimed at improving infrastructure provision, safety and route choice for pedestrians, cyclists and equestrians. Specific route considerations include: ",
              "1. An upgrade of The Thicket between St Ives town centre and Houghton, on-road improvements through Houghton and Wyton and improved off-road provision between Huntingdon Road, Wyton, and Old Houghton Road, Huntingdon. ",
              "2. Connection and upgrade of the Hill Rise footway to the B1040 via Marley Way to connect leisure uses off Hill Rise and also provide a connection to the Nuffield Road industrial estate and to the east of the B1040 to the proposed Gifford’s Farm development",
              "3. Localised improvements to the network to the north of the A1123 to improve safety and perceptions of safety, connect existing route and provide new routes along desire lines.",
              "4. Localised improvements to the network to the north of the A1123 to improve safety and perceptions of safety, connect existing route and provide new routes along desire lines.",
              "5. Improvements to Low Road to make the route more friendly for pedestrians, cyclists and equestrians to connect through Fenstanton to the new NMU route alongside the A1307 into Cambridge. ",
              "6. Improvements to the consistency of NMU route along the A1123 through St Ives and between St Ives and Huntingdon. ",
              "7. Reconnecting Old Ramsey Road and St Ives Road between Old Hurst and St Ives to provide an off-road connection from north of St Ives. ",
            ],
            map: "https://firebasestorage.googleapis.com/v0/b/st-ives-d8044.appspot.com/o/Maps%2Fmap6.png?alt=media&token=83bfeb96-0ac5-4fe5-949a-573b75f0f8fc",
          },
        ],
      },
    };
  },
};
</script>